import { useMemo } from "react";
import { useRouter as nextRouter } from "next/router";
import { parse, stringify as qsStringify } from "qs";

import { ShopTypes } from "custom-types/Shop";

export type CustomQuery = {
  brandReferral?: string;
  deal_active?: string;
  q?: string;
  page?: string;
  product_category?: string;
  searchCategory?: string;
  shopCategory?: ShopTypes;
  shopName?: string;
  slug?: string;
  sort?: string;
  sort_direction?: string;
  strain_category?: string;
  strain_name?: string;
  [key: string]: string | string[] | undefined;
};

const useRouter = () => {
  const router = nextRouter();
  const { route, asPath } = router;

  // String portions of the URL
  const [urlString, hashString] = asPath.split("#");
  const [pathString, queryString] = urlString.split("?");

  // Only query values (no Next params), parsed using qs
  const parsedQuery = useMemo(
    () => parse(queryString) as CustomQuery,
    [queryString]
  );
  const { q: searchTerm } = parsedQuery;

  // qs function for stringifying with bracket format
  const stringify = (object: {
    [key: string]: string | string[] | boolean | undefined;
  }) =>
    qsStringify(object, { arrayFormat: "brackets", encodeValuesOnly: true });

  // This is moved from web-dispensary. Seems scary, left the original logic in place.
  const oldBaseRoute = {
    as: pathString.split("/").slice(0, 3).join("/"),
    href: route.split("/").slice(0, 3).join("/"),
  };
  const generateOldTabLink = ({
    tab,
    query,
  }: {
    tab?: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
    query?: any;
  }) => {
    const hrefTab = `${tab ? `/[tab]` : ""}`;
    const asTab = `${tab ? `/${tab}` : ""}`;
    const queryString = query ? `?${stringify(query)}` : "";

    return {
      as: oldBaseRoute.as + asTab + queryString,
      href: oldBaseRoute.href + hrefTab + queryString,
    };
  };

  return {
    ...router,
    generateOldTabLink,
    hashString,
    parsedQuery,
    pathString,
    queryString,
    searchTerm,
    stringify,
  };
};

export default useRouter;
